<template>
  <div class="journey-edit" @scroll="handleScroll" ref="journeyEdit">
    <div class="sticky">
        <div class="edit-stage">
        <div class="stage-div">
            <div class="stage-num">{{codeTxt.substring(0, 2)}}</div>
            <div class="stage-title">{{stageTxt}}</div>
        </div>
        <div class="submit-btn" :class="isLoading?'no-click':''" @click="handleSubmit">保存</div>
        </div>
    </div>
    <div id="iep-course" class="div-con">
      <div class="title">iEP课程</div>
      <input
        type="text"
        placeholder="点击选择课程"
        class="course-input"
        readonly
        @click="handleClickJump('course')"
      />
      <div class="tip">已选择课程</div>
      <div class="list-act">
        <div
          class="item"
          v-for="(item_check, key_check) in courseList"
          :key="key_check"
        >
          <img src="@/assets/images/cartojourney/img19.png" @click="handleDel('course', key_check)" class="icon-del" alt="">
          <img :src="item_check && item_check.coverMaterialUrl" class="item-cover course-cover" alt="" />
          <div class="item-cons">
            <div class="cons-name">{{ item_check && item_check.name }}</div>
            <div class="cons-flex">
              <div class="flex-times">讲师: {{ item_check && item_check.lecturersName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { stageCoursesList, courseBatchSave } from '@/api/grade'
import {debounce} from '@/utils/util'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data() {
    return {
      value: 1,
      activeTab: 'growth-cycle',
      sections: ['growth-cycle', 'iep-course', 'academic-activities'],
      sectionPositions: {},
      courseList: [],
      activityList: [],
      selectCycle: {},
      codeTxt: '',
      stageTxt: '',
      classId: '',
      journeyId: '',
      stageId: '',
      isLoading: false,
    }
  },
  computed: {
  },
  mounted() {
    this.classId = this.$route.query.classId
    this.journeyId = this.$route.query.journeyId
    this.stageId = this.$route.query.stageId
    this.codeTxt = this.$route.query.codeTxt
    this.stageTxt = this.$route.query.stageTxt
    if (!sessionStorage.getItem('gradeSelectCourse')) {
      this.handleStageCoursesList()
    } else {
      this.courseList = JSON.parse(sessionStorage.getItem('gradeSelectCourse'))
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateSectionPositions)
  },
  methods: {
    // 数据处理
    handleSetList(item) {
      let list = []
      item.filter(acc => {
        let obj = {
          name: acc.courseDTO.name,
          stageId: acc.stageId,
          myUnlock: acc.courseDTO.coverMaterial.myUnlock,
          learningStatus: '',
          journeyId: acc.journeyId,
          isUnlock: acc.isUnlock,
          isCheck: true,
          id: acc.courseDTO.id,
          courseId: acc.courseDTO.id,
          createTime: acc.createTime,
          coverMaterialUrl: acc.courseDTO.coverMaterial.url,
          coverMaterialId: acc.courseDTO.coverMaterial.id,
          coverMaterial: acc.courseDTO.coverMaterial,
          lecturersName: acc.courseDTO.lecturersName || '无',
          courseType: '',
          courseLecturers: '',
        }
        list.push(obj)
      })
      this.courseList = list
      sessionStorage.setItem('gradeSelectCourse', JSON.stringify(list))
    },
    // 课程列表
    handleStageCoursesList() {
      const params = {
        classId: this.classId,
        journeyId: this.journeyId,
        stageId: this.stageId
      }
      stageCoursesList(params).then(res => {
        this.handleSetList(res.data)
      })
    },
    handleDel(type, index) {
      if (type === 'course') {
        this.courseList.splice(index, 1)
        sessionStorage.setItem('gradeSelectCourse', JSON.stringify(this.courseList))
      }
    },

    handleSubmit: debounce(function() {
      this.isLoading = true
      let params = {
        classId: this.classId,
        journeyId: this.journeyId,
        stageId: this.stageId,
        courseIds: this.courseList.map(res => (res.courseId) ? res.courseId : res.id)
      }
      courseBatchSave(params).then(res => {
        sessionStorage.removeItem('gradeSelectCourse')
        this.$router.go(-1)
        this.isLoading = false
      })
    }, 500),
    handleClickJump(type) {
      if (type === 'course') {
        this.$router.push({
          path: '/gradeSelectCourse',
          query: {
            // journeyId: this.currentJourney.id,
            // stageId: item.id,
            customizedCode: this.classId,
            customizedJourneyId: this.journeyId,
            customizedStageId: this.stageId,
            classId: this.classId,
          }
        })
      }
    },
    handleScroll() {
      const scrollTop = this.$refs.journeyEdit.scrollTop
      let newActiveTab = this.activeTab
      for (let i = 0; i < this.sections.length; i++) {
        if (
          scrollTop >= this.sectionPositions[this.sections[i]] &&
          (!this.sectionPositions[this.sections[i + 1]] ||
            scrollTop < this.sectionPositions[this.sections[i + 1]])
        ) {
          newActiveTab = this.sections[i]
          break
        }
      }
      if (newActiveTab !== this.activeTab) {
        this.activeTab = newActiveTab
      }
    },
    updateSectionPositions() {
      this.sections.forEach(sectionId => {
        const element = document.getElementById(sectionId)
        if (element) {
          this.sectionPositions[sectionId] = element.offsetTop - 128
        }
      })
    },
    scrollToSection(sectionId) {
      this.activeTab = sectionId
      const element = document.getElementById(sectionId)
      if (element) {
        this.$refs.journeyEdit.scrollTo({
          top: element.offsetTop - 128,
          behavior: 'smooth'
        })
      }
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.journey-edit {
  background-color: #f0f1f6;
  height: 100vh;
  overflow: auto;
  .sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1000;
    background-image: url('../../../assets/images/cartojourney/img01.png');
    background-size: 100%;
    background-repeat: no-repeat;
  }
  .edit-stage {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 64px;
    padding: 0 12px;
    box-sizing: border-box;
    position: relative;
    .stage-div {
      display: flex;
      align-items: center;
      .stage-num {
        margin-right: 6px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: radial-gradient(
          circle at 32% 75%,
          #ff8274 0%,
          #eb1700 54%,
          #ffa69d 100%
        );
        color: #fff;
        text-align: center;
        line-height: 30px;
        font-weight: 500;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-size: 14px;
      }
      .stage-title {
        font-size: 16px;
        font-weight: 500;
        color: #000;
      }
    }
    .submit-btn {
      width: 58px;
      text-align: center;
      line-height: 28px;
      background-color: #eb1700;
      border-radius: 100px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-size: 14px;
      color: #ffffff;
    }
    .no-click {
      pointer-events: none;
    }
  }
  .flex-div {
    background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.67) 100%
      ),
      rgba(255, 255, 255, 0.7);
    position: relative;
    border-radius: 12px 12px 0 0;
    .flex-nav {
      display: flex;
      align-items: center;
      height: 42px;
      .nav-txt {
        display: block;
        text-align: center;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-size: 14px;
        color: #333333;
        flex: 1;
        cursor: pointer; // 设置鼠标悬停时显示为可点击状态
        &.cur {
          font-weight: 600;
          color: #eb1700;
          position: relative;
          height: 42px;
          line-height: 42px;
          &::after {
              position: absolute;
              bottom: 4px;
              left: 50%;
              transform: translateX(-50%);
              content: '';
              width: 23px;
              height: 9px;
              background-image: url('../../../assets/images/cartojourney/img18.png');
              background-repeat: no-repeat;
              background-size: 100%;
          }
        }
      }
    }
  }
  .div-con {
    background-color: #fff;
    border-radius: 12px;
    padding: 10px 12px;
    box-sizing: border-box;
    position: relative;
    margin: 12px 10px;
    .title {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 16px;
      color: #282828;
      line-height: 20px;
      position: relative;
      display: inline-block;
      &::after {
        position: absolute;
        right: -20px;
        bottom: 2px;
        content: "";
        background-image: url("../../../assets/images/cartojourney/img17.png");
        background-repeat: no-repeat;
        background-size: 100%;
        width: 46px;
        height: 9px;
      }
    }
    .cons {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 18px;
      padding-bottom: 10px;
      .label {
        font-family: PingFang HK, PingFang HK;
        color: rgba(0, 0, 0, 0.6);
        font-size: 14px;
      }
      .val {
        display: flex;
        align-items: center;
        .unit {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-size: 14px;
          color: #282828;
          margin-left: 6px;
        }
      }
    }
    .course-input {
        display: block;
        width: 100%;
        border-radius: 4px;
        border: 1px solid rgba(0,0,0,0.2);
        height: 40px;
        box-sizing: border-box;
        font-family: PingFang HK, PingFang HK;
        font-size: 14px;
        padding-left: 16px;
        outline: none;
        margin-top: 24px;
        margin-bottom: 12px;
    }
    .tip {
        font-family: PingFang HK, PingFang HK;
        color: rgba(0,0,0,0.6);
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 8px;
    }
    .list-act {
      .item {
        display: flex;
        padding: 8px 10px;
        box-sizing: border-box;
        background-color: #F5F6F9;
        border-radius: 4px;
        margin-top: 8px;
        position: relative;
        &.item-act {
            align-items: center;
            .item-cons {
                .cons-name {
                    margin-bottom: 0;
                }
            }
        }
        .icon-del {
            width: 13px;
            height: 13px;
            position: absolute;
            right: 1px;
            top: 1px;
        }
        .item-cover {
          width: 32px;
          height: 32px;
          display: block;
          margin-right: 4px;
          &.course-cover {
            width: 116px;
            height: 68px;
            object-fit: cover;
            border-radius: 4px;
          }
        }
        .item-cons {
          display: flex;
          flex-direction: column;
          flex: 1;
          .cons-name {
            font-family: PingFang HK, PingFang HK;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            margin-bottom: 6px;
            display: -webkit-box;
            /* 盒子类型 */
            word-break: break-all;
            /* 自动换行的处理方法。允许在单词内换行 */
            text-overflow: ellipsis;
            /* 溢出时用... */
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;

          }
          .cons-flex {
            display: flex;
            justify-content: space-between;
            flex: 1;
            height: 20px;
            .flex-times {
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-size: 13px;
              color: #b1b1b1;
            }
            .status {
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-size: 12px;
              color: #eb1700;
              &.none {
                background-color: #eb1700;
                color: #fff;
                text-align: center;
                width: 46px;
                border-radius: 100px;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/journeyEdit.vue